module.exports = {
  email: 'sabeehmirza9@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/sabeehmurtaza9',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/sabeehmirza9/',
    },
    {
      name: 'Twitter',
      url: 'https://x.com/SabeehMirza9',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/sabeehmirza/',
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/sabeehmirza9',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#3FAE8E', // #64ffda,
    navy: '#12332a', // #0a192f
    darkNavy: '#0a1f19', // #020c1b
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
